module.exports = __webpack_public_path__ + "img/loginbg.a7aef6a5.png";